define('plugin/bonus/controller/BonusController',['require','lib/controller/BaseController','plugin/bonus/collection/BonusCollection','plugin/bonus/model/BonusModel','plugin/bonus/view/BonusLayout','plugin/bonus/view/ClientInfoBonusListView','lib/pager/Pager','lib/plugin/PluginBroker','lib/Utils','Config'],function (require) {

    var BaseController = require('lib/controller/BaseController');
    var BonusCollection = require('plugin/bonus/collection/BonusCollection');
    var BonusModel = require('plugin/bonus/model/BonusModel');
    var BonusLayout = require('plugin/bonus/view/BonusLayout');
    var ClientInfoBonusListView = require('plugin/bonus/view/ClientInfoBonusListView');
    var Pager = require('lib/pager/Pager');

    var PluginBroker = require('lib/plugin/PluginBroker');
    var Utils = require('lib/Utils');
    var Config = require('Config');

    /**
     * Bonus Controller
     *
     * @class BonusController
     */
    return BaseController.extend({
        _view : null,
        _message : null,
        _clientModel : null,

        initialize: function () {
            var _this = this;
            //this._paymentSystemCollection = this.getOption('paymentSystemCollection');
            this.initCollection();

            this._clientModel = this.getOption('client');

            if (Config.getInstance().getPluginStatus('client_login')) {
                var clientPlugin = PluginBroker.getInstance().getPlugin('client_login');
                this._clientModel = clientPlugin.getClientModel();
            }
            var messagesClientLoginChannel = Backbone.Wreqr.radio.channel('client_login');

            messagesClientLoginChannel.vent.on('client:signout', function () {
                if(_this._isCurrentController()) {
                    _this._redirectWithReplace('client/sign-in/back/' + encodeURIComponent('bonus'));
                }
            });

            BaseController.prototype.initialize.apply(this);
        },

        /**
         * Initializes collection
         */
        initCollection: function () {
            this._pager = new Pager();
            this._pager.setOnPage(999999); //do not show pages
            this._pager.setSkipPagination(false); //do not show pages

            this._collection = new BonusCollection({
                pager: this._pager
            });

            this.listenTo(this._collection, 'error',  _.bind(function (model, xhr) {
                var result = xhr.responseJSON;
                if (result && result.login_client) {
                    if (Config.getInstance().getPluginStatus('client_login')) {
                        this._redirectWithReplace('client/sign-in/back/' + encodeURIComponent('bonus'));
                    } else{
                        this.showErrorMessage(_T('Client login error'));
                    }
                } else {
                    this.showErrorMessage(result.error);
                }
            }, this));
        },

        _isCurrentController : function(){
            if(this._clientInfoListView && !this._clientInfoListView.isDestroyed){
                return true;
            }
            if(this._bonusLayout && !this._bonusLayout.isDestroyed){
                return true;
            }
            return false;
        },

        info: function(page){

            this._clientInfoListView = new ClientInfoBonusListView({
                collection: this._collection,
            });
            this._pager.trigger('change');
            this._clientInfoListView.setPage(this._pager.getPage());
            this._clientInfoListView.setOnPage(this._pager.getOnPage());

            this.getMainLayout().getContentRegion().show(this._clientInfoListView);

            this.listenTo(this._clientInfoListView, 'page:changed', this.triggerPageShown);

            return this._clientInfoListView;
        },

        /**
         * Triggers page shown to scroll up to products
         */
        triggerPageShown: function () {
            Backbone.Wreqr.radio.vent.trigger('page', 'shown', {
                'page': 'bonus'
            });
        },

        pay: function (id, isReturn) {
            this.view(id, isReturn);
        },

        view: function (id, isReturn) {
            this._bonusModel = new BonusModel({id: id});
            this._bonusModel.fetch();

            this.listenTo(this._bonusModel, 'sync', _.bind(function () {
                this._viewBonus(id, isReturn, true);
            }, this));

            this.listenTo(this._bonusModel, 'error', _.bind(function (model, xhr) {
                var data = {};
                if(xhr && xhr.responseJSON){
                    data = xhr.responseJSON;
                }
                if (data && data.login_client) {
                    this._redirectWithReplace('client/sign-in/back/' + encodeURIComponent('bonus/pay/' + id));
                }
                if(data.error) {
                    this.showErrorMessage(data.error, true);
                }
            }, this));
        },


        _viewBonus: function (id, isReturn) {
            var _this = this;
            var paymentAllowed = true;

            var view = new BonusLayout({
                model: this._bonusModel,
                clientModel: this._clientModel,
                paymentAllowed: !isReturn,
                isReturn: isReturn
            });
            this._bonusLayout = view;

            this.listenTo(this._bonusLayout, 'confirm:bonus:payment', this._confirmPayment);

            this.getMainLayout().getContentRegion().show(this._bonusLayout);

            this._onBonusShown(isReturn, paymentAllowed);
        },

        _onBonusShown : function (isReturn){

        },

        _confirmPayment : function (){
            this._bonusModel.confirmPayment().then(
                _.bind(function (data) {
                    if (data && data.id) {
                        this._redirectWithReplace('bonus/view/' + data.id);

                        if(this._clientModel){
                            this._clientModel.fetch({reset: true});
                        }
                    }
                }, this),
                _.bind(function (result) {
                    this.showErrorMessage(result.error, true);
                }, this)
            );
        },

        showErrorMessage: function (error, redirectTo404) {
            if (this._bonusLayout && !this._bonusLayout.isDestroyed) {
                this._bonusLayout.showErrorMessage(error);
            } else {
                if(redirectTo404){
                    setTimeout(function () {
                        Backbone.history.navigate('error/e404', {
                            trigger: true,
                            replace: true
                        });
                    });
                } else {
                    this._message = error;
                    this._redirect('bonus/info');
                }
            }
        },

    });

});
